import {  Component, Inject, Input, OnChanges, SimpleChanges
       } from '@angular/core';

import { TranslationService } from './translation.service';

@Component({
  selector: 'translate',
  template: `{{ output }}`,
})
export class TranslationComponent implements OnChanges
{
  @Input() public key: string;
  @Input() public plural: number;
  @Input() public values: any;

  public output: string;

  constructor(@Inject(TranslationService) private translationService) {}

  public ngOnChanges(changes: SimpleChanges): void
  {
    if (this.plural === undefined) {
      this.plural = 1;
    }

    this.output =
        this.translationService.get(this.key, this.plural, this.values);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/translation/translation.component.ts